<script>
export default
{
    name: 'view-title',

    props:
    {
        backAction: { type: Boolean|Function, default: true },
    },

    created ()
    {
    },

    render () 
    {
        return (
            <div class={`view-title ${this.backAction ? 'has-back-action' : ''}`} on-click={this.onClick}>
                { this.backAction && <div class='back'>←</div> }
                { this.$slots.default }
            </div>
        )
    },

    mounted ()
    {
    },

    data () 
    {
        return {
        }
    },

    computed:
    {
    },

    methods:
    {
        onClick ()
        {
            if (typeof this.backAction == 'function') this.backAction()
            else if (this.backAction) this.$router.back()
            this.$emit('click')
        }
    },

    components:
    {
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

.view-title
{
    font-size: 6vw;
    font-weight: 800;
    margin-top: 13vw;
    margin-bottom: 6vw;
    margin-right: 20vw;
    margin-left: 2px;

    .OnTablet({
        font-size: 3vw;
        margin-bottom: 5vw;
    });

    .OnDesktop({
        margin-top: 4vw;
        margin-right: 5vw;
        margin-bottom: 2vw;
        font-size: 1.5vw;
    });

    &.has-back-action
    {
        cursor: pointer;
    }

    .back
    {
        cursor: inherit;
        display: inline;
        margin-right: 5px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/ViewTitle.vue